/** FLD-OFF-FIX / FIX-3 — connection state for the app.
 *
 *  The judgement itself moved to `link.js` (FLD-OFF-FIX-3): offline is derived from repeated REAL
 *  network failures only, measured off the main thread, per device profile. This module stays as
 *  the app-facing face of it — the manual "Work offline" switch, the wording, and the two helpers
 *  the interceptors and the outbox already call.
 */
import { checkLink, classify, isLinkDown, lastCheckedAt, lastReason, linkQuality, noteFail, noteOk, onLink, PROFILE } from "./link";

const MANUAL_KEY = "fieldops-work-offline";

const listeners = new Set();
export const onQuality = (fn) => {
  listeners.add(fn);
  const off = onLink(() => fn());
  return () => { listeners.delete(fn); off(); };
};
const emit = () => listeners.forEach((fn) => { try { fn(); } catch { /* ui */ } });

let manual = typeof localStorage !== "undefined" && localStorage.getItem(MANUAL_KEY) === "1";
export const isManualOffline = () => manual;
export function setManualOffline(v) {
  manual = !!v;
  try { localStorage.setItem(MANUAL_KEY, manual ? "1" : "0"); } catch { /* private mode */ }
  emit();
  return manual;
}

/** Kept for the two existing call sites. `ok` true = the server answered (any status). */
export function noteResult(ok, ms, opts = {}) {
  if (ok) noteOk(ms, opts);
  else noteFail(opts);
}

/** good — sync freely · weak — slower than usual, behaviour unchanged · offline — local only. */
export function quality() {
  if (manual) return "offline";
  return linkQuality();
}

export const qualityLabel = () => (manual ? "Working offline"
  : { good: "Good signal", weak: "Weak signal", offline: "No signal" }[quality()]);

/** When the detector last had an answer out of the network, for the chip ("checked 12:40:05"). */
export const checkedAt = () => lastCheckedAt();
export const offlineReason = () => lastReason();
export const profileName = () => PROFILE.label;

/** One tiny uncached request in a Web Worker — the only way back that heavy work cannot delay. */
export async function probe() {
  if (manual) return false;
  return checkLink();
}

export { classify, isLinkDown, noteOk, noteFail };
